import { render, staticRenderFns } from "./FactoryInvoicesListPage.vue?vue&type=template&id=5d2d9fd6&scoped=true&"
import script from "./FactoryInvoicesListPage.vue?vue&type=script&lang=ts&"
export * from "./FactoryInvoicesListPage.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryInvoicesListPage.vue?vue&type=style&index=0&id=5d2d9fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d9fd6",
  null
  
)

export default component.exports